import { sectionEditService } from '../services'

export default (id) => {
 	return new Promise((resolve, reject) => {
		sectionEditService.deleteDataSource(id)
 			.then(response => resolve(response.data))
			.catch(error => reject(error)
		);
 	})
}
